import React, { useMemo } from "react";
import { Tabs, Tab, TabProps } from "react-bootstrap";
import { EventKey } from "react-bootstrap/types";
import { Breakpoint } from "react-socks";

import "./PillTabs.scss";
import Dropdown from "../Dropdown/Dropdown";

type TabsProps = {
  id?: string;
  onSelect: any;
  activeKey: EventKey;
  defaultActiveKey?: EventKey;
  tabItems: Array<TabProps>;
  isResponsive?: boolean;
  variant?: string;
};

function PillTabs(props: TabsProps) {
  const { id, activeKey, onSelect, defaultActiveKey, tabItems, isResponsive, variant } = props;
  const renderTabTitle = (item: TabProps) => {
    const testId = (item as any)?.testId as string | undefined;
    if (!testId) return item.title;
    return <span data-testid={testId}>{item.title}</span>;
  };

  const activeOptions = useMemo(
    () =>
      tabItems
        .filter((item) => item && !item.disabled)
        .map((item) => ({ label: item.title as string, value: item.eventKey as string })),
    [tabItems],
  );

  const breakpointWidth = activeOptions.length >= 7 ? 975 : 767;

  if (!isResponsive)
    return (
      <Tabs className="tab-container" id={id} activeKey={activeKey} onSelect={onSelect} defaultActiveKey={defaultActiveKey}>
        {tabItems.map((item, idx) => (
          <Tab
            key={item.eventKey || idx}
            tabClassName="tab-item font-b2"
            eventKey={item.eventKey}
            title={renderTabTitle(item)}
            disabled={item.disabled}
            variant={variant}
          />
        ))}
      </Tabs>
    );

  return (
    <div>
      <Breakpoint customQuery={`(max-width: ${breakpointWidth}px)`}>
        {isResponsive && (
          <Dropdown
            value={activeKey}
            defaultValue={defaultActiveKey as string}
            options={activeOptions}
            onChange={(val: any) => {
              onSelect(val.value);
            }}
          />
        )}
      </Breakpoint>

      <Breakpoint customQuery={`(min-width: ${breakpointWidth + 1}px)`}>
        <Tabs
          className="tab-container"
          id={id}
          activeKey={activeKey}
          onSelect={onSelect}
          defaultActiveKey={defaultActiveKey}
        >
          {tabItems.map((item, idx) => (
            <Tab
              key={item.eventKey || idx}
              tabClassName="tab-item font-b2"
              eventKey={item.eventKey}
              title={renderTabTitle(item)}
              disabled={item.disabled}
              variant={variant}
            />
          ))}
        </Tabs>
      </Breakpoint>
    </div>
  );
}

export default PillTabs;

PillTabs.defaultProps = {
  id: "",
  defaultActiveKey: "",
  variant: "",
  isResponsive: true,
};
